import { useEffect } from "react";

/**
 * useInViewClass(containerRef, childSelector, className, options)
 * - observe chaque enfant direct matching childSelector à l'intérieur de containerRef.current
 * - ajoute className quand l'enfant croise le viewport
 */
export default function useInViewClass(
  containerRef,
  childSelector = "figure",
  className = "is-visible",
  { root = null, rootMargin = "0px 0px -80px 0px", threshold = 0.12 } = {}
) {
  useEffect(() => {
    const container = containerRef?.current;
    if (!container) return;

    const nodes = Array.from(container.querySelectorAll(childSelector));
    if (!nodes.length) return;

    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const el = entry.target;
          if (entry.isIntersecting) {
            el.classList.add(className);
            obs.unobserve(el);
          }
        });
      },
      { root, rootMargin, threshold }
    );

    nodes.forEach((n) => obs.observe(n));

    return () => {
      nodes.forEach((n) => obs.unobserve(n));
      obs.disconnect();
    };
  }, [containerRef, childSelector, className, rootMargin, threshold, root]);
}
